export default __webpack_public_path__ + "static/media/Chris-Krimitsos.245ecb69.jpeg";